import type { ComponentProps, ElementType, ForwardRefRenderFunction } from "react";
import { forwardRef } from "react";

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types  -- здесь не проверяем */

/**
 * @beta
 */
export type As<Props = any> = ElementType<Props>;
/**
 * @beta
 */
export type PropsWithAs<Props = {}, Type extends As = As> = Props &
  Omit<ComponentProps<Type>, "as" | keyof Props> & {
    as?: Type;
  };
/**
 * @beta
 */
export type ComponentWithAs<Props, DefaultType extends As> = {
  <Type extends As>(props: PropsWithAs<Props, Type> & { as?: Type }): JSX.Element;
  (props: PropsWithAs<Props, DefaultType>): JSX.Element;
  displayName?: string;
};

/**
 * @beta
 */
export function forwardRefWithAs<Props, DefaultType extends As>(
  component: ForwardRefRenderFunction<any, any>
) {
  return forwardRef(component) as unknown as ComponentWithAs<Props, DefaultType>;
}
/* eslint-enable -- здесь не проверяем */
